import React from "react"
import TextBundle from "aldoo-ra/CMS/text-bundle"

export default function StatusBadge({ status, plain = false }) {
  const texts = TextBundle({ id: "transfer_share_dashboard" })
  const s = status?.toLowerCase() || ""
  const labels = {
    active: texts?.statusActive,
    completed: texts?.statusActive,
    grace: texts?.statusGrace,
    expired: texts?.statusExpired,
    paused: texts?.statusPaused,
  }
  const label = labels[s] || status

  if (plain) {
    let textClass = "text-text_secondary"
    if (s === "active" || s === "completed") textClass = "text-primary_dk"
    else if (s === "expired" || s === "cancelled") textClass = "text-error"
    else if (s === "paused") textClass = "text-warning"
    else if (s === "grace") textClass = "text-progress"
    return <span className={`text-sm font-medium ${textClass}`}>{label}</span>
  }

  let colorClass = "bg-progress"
  if (s === "active" || s === "completed")
    colorClass = "bg-success text-text_inv"
  else if (s === "expired" || s === "cancelled")
    colorClass = "bg-error text-text_inv"
  else if (s === "paused") colorClass = "bg-warning text-text_inv"
  else if (s === "grace") colorClass = "bg-progress text-text_inv whitespace-nowrap"

  return (
    <div className={`inline-block px-3 py-0.5 text-sm rounded-full ${colorClass}`}>
      {label}
    </div>
  )
}
